// import React from 'react';

import { EllipseSelection } from './EllipseSelection';

export const useEllipses = () => ({
  SingleValue: EllipseSelection,
});
